var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgDefaultUploadFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H28L34 6L40 12V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#41454B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 0L34 6L40 12H32C29.7909 12 28 10.2091 28 8V0Z",
    fill: "#30353B"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultUploadFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/default-upload-file.5ebac8a8ddca723ffda085f4402e8170.svg";